import type { ImageWithPreview } from '@modules/page-builder/types';

export type ImagesWithPreviewPromise = ImageWithPreview[] | Event;

const createPreviewImage = async (
    file: ImageWithPreview
): Promise<ImageWithPreview> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const source = (reader.result || '') as string;
            file['preview'] = source;

            const image = new Image();
            image.src = source;
            image.onload = () => {
                file['height'] = image.height;
                file['width'] = image.width;
                file['orientation'] =
                    image.width > image.height ? 'landscape' : 'portrait';
                file['aspectRatio'] =
                    image.height > 0 ? image.width / image.height : 0;
                resolve(file);
            };
            image.onerror = (e) => {
                reject(e);
            };
        };
        reader.onerror = (e) => {
            reject(e);
        };
    });
};

export const createPreviewImages = async (
    files: File[]
): Promise<ImagesWithPreviewPromise> => {
    const promises = files.map((file: ImageWithPreview) => {
        return createPreviewImage(file);
    });

    return await Promise.all(promises).catch((err) => {
        return err;
    });
};
